export const NAME_NOT_PROVIDED = '';
export const BUSINESS_UNIT_WFA_TABLE_ID = 'business-unit-wfa-table';
export const BUSINESS_UNIT_WEB_SDK_TABLE_ID = 'business-unit-web-sdk-table';
export const ALL_ISSUES_TABLE_ID = 'all-issues-table';
export const UNIQUE_ISSUES_TABLE_ID = 'unique-issues-table';
export const LOCALE_EN_US = 'en-US';
